// 用户数据
import request from '../../utils/request'
import { UrlSearch } from '../../utils/UrlSearch'
const shopTitle = UrlSearch().shop
let shopName
if (shopTitle) {
  let index = shopTitle.indexOf('.')
  if (index > 0) {
    shopName = shopTitle.substring(0, index)
  } else {
    shopName = shopTitle
  }
}

export function setuser (param) {
  // param.shopName = shopName;
  return request({
    url: `check-login`,
    method: 'post',
    params: param
  })
}

export function gettokenuser (param) {
  console.log(param)
  // param.shopName = shopName;
  return request({
    url: `get-token`,
    method: 'post',
    params: param
  })
}
export function loginfromshopify (param) {
  // param.shopName = shopName;
  return request({
    url: `check-login-fromshopify`,
    method: 'post',
    params: param
  })
}
export function install (param) {
  // param.shopName = shopName;
  return request({
    url: `shopify-install`,
    method: 'post',
    params: param
  })
}

export function getcountry () {
  let param = {}
  param.shopName = shopName
  return request({
    url: `get-country`,
    method: 'post',
    params: param
  })
}
export function getcurrency (param) {
  param.shopName = shopName
  return request({
    url: `get-currency-info`,
    method: 'post',
    params: param
  })
}

export function paypal (param) {
  param.shopName = shopName
  return request({
    url: `go-to-paypal`,
    method: 'post',
    params: param
  })
}
export function register (params) {
  // params.shopName = shopName;
  return request({
    url: 'register',
    method: 'POST',
    params: params
  })
}
// 查询邮箱
export function getShopInf (params) {
  params.shopName = shopName
  return request({
    url: 'get-shop-inf',
    method: 'POST',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/components/views/api/user.js